angular.module('edxComponents')
  .component('edxNweaAssignmentBlurb', {
    templateUrl: '/resources/components/assign-focus/create-nwea-assignment/nwea-assignment-blurb.component.html',
    controller: [NweaAssignmentBlurbController],
    controllerAs: 'vm',
    bindings: {}
  });

function NweaAssignmentBlurbController() {
}
